<template>
    <div class="withdraw">
        <div class="withdraw_top">
            <div class="withdraw_tit">           
                <div class="go_back"></div>
                <div class="withdraw_name">提现</div>
            </div>
            <div class="withdraw_menu">
                <div class="withdraw_title">可提奖金</div>
                <div class="withdraw_nav">
                    <div class="nav_num">10.00</div>
                    <div class="nav_all">全部提现</div>
                </div>
            </div>
        </div>
        <div class="withdraw_ali">
            <div class="ali_check"></div>
            <div class="ali_info"><span class="ali_icon"></span>提现支付宝账号</div>
            <div class="ali_edit">修改账号<span class="edit_go"></span></div>
        </div>
        <div class="withdraw_weixin">
            <div class="weixin_check"></div>
            <div class="weixin_info"><span class="weixin_icon"></span>提现微信</div>
        </div>       
        <div class="withdraw_sam">
            <div class="sam_name">提现金额</div>
            <div class="sam_input">
                <input type="text" class="sam" placeholder="请输入提现金额">
            </div>
        </div>   
        <div class="with_true">确认提现</div>  
    </div>
</template>
<script>
     export default {
        name: 'Withdraw',
        data () {
             return {

             }
        },
      }
</script>
<style scoped>
.withdraw{width:100%;height:100%;background:#F8F8F8;position: relative;}
.withdraw_top{width:100%;height:180px;background:url(/static/images/withdraw.png) no-repeat center center;padding-top:40px;background-size:100% 100%;}
.withdraw_tit{width:720px;height:48px;margin:0 auto; display: flex;justify-content: flex-start;}
.withdraw_tit .go_back{width:48px;height:48px;background:url(/static/images/team_go_back.png) no-repeat center center;background-size:100% 100%;}
.withdraw_tit .withdraw_name{color:#333333;font-size:34px;font-weight:600;margin-left:280px;}
.withdraw_menu{width:698px;height:138px;background:#FFF;margin:0 auto;margin-top:42px;padding-top:42px;border-radius:20px;}
.withdraw_menu .withdraw_title{font-size:28px;color:#333334;padding-left:32px;}
.withdraw_menu .withdraw_nav{display: flex;justify-content:space-between;width:634px;margin:0 auto;margin-top:12px;}
.withdraw_menu .nav_num{color:#FE3B30;font-size:36px;font-weight:bold;}
.withdraw_menu .nav_all{width:156px;height:52px;border-radius:26px;color:#333334;font-size:28px;text-align: center;background:#FFE514;line-height: 52px;position: relative;top:-20px;}
.withdraw_ali{width:698px;height:124px;margin:0 auto;margin-top:120px;display: flex;align-content: flex-start;line-height:124px;border-radius:20px;background:#FFF;}
.withdraw_ali .ali_check{width:40px;height:40px;background:url(/static/images/check.png) no-repeat center center;background-size:100% 100%;margin-top:40px;margin-left:30px;}
.withdraw_ali .ali_icon{width:64px;height:64px;background:url(/static/images/ali.png) no-repeat center center;background-size:100% 100%;display: inline-block;vertical-align: middle;margin-left:30px;margin-right:22px;}
.withdraw_ali .ali_info{font-size:28px;color:#000000;}
.withdraw_ali .ali_edit{margin-left:156px;font-size:24px;color:#9B9B9B;position: relative;}
.withdraw_ali .ali_edit .edit_go{
    width: 24px;
    height: 24px;
    position: absolute;
    border-bottom: 1px solid #9B9B9B;
    border-right: 1px solid #9B9B9B;
    top:48px;
    left: 100px;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
}
.withdraw_weixin{width:698px;height:124px;margin:0 auto;margin-top:26px;display: flex;align-content: flex-start;line-height:124px;border-radius:20px;background:#FFF;}
.withdraw_weixin .weixin_check{width:40px;height:40px;background:url(/static/images/checked.png) no-repeat center center;background-size:100% 100%;margin-top:40px;margin-left:30px;}
.withdraw_weixin .weixin_icon{width:64px;height:64px;background:url(/static/images/weixin.png) no-repeat center center;background-size:100% 100%;display: inline-block;vertical-align: middle;margin-left:30px;margin-right:22px;}
.withdraw_weixin .weixin_info{font-size:28px;color:#000000;}
.withdraw_sam{width:698px;height:124px;margin:0 auto;margin-top:26px;display: flex;justify-content: space-between;flex-wrap: wrap;line-height:124px;border-radius:20px;background:#FFF;}
.withdraw_sam .sam_name{margin-left:30px;font-size:28px;color:#333334;}
.withdraw_sam .sam_input{margin-right:32px;width:196px;height:40px;}
.withdraw_sam .sam_input .sam{line-height:40px;width:100%;font-size:28px;border:none;}
.with_true{width:698px;height:100px;background:#FFE514;border-radius:50px;line-height:100px;text-align: center;font-size:32px;color:#333334;position: absolute;left:0; right:0;bottom:26px;margin:auto;}
</style>


// WEBPACK FOOTER //
// src/components/person/withdraw.vue